export default __webpack_public_path__ + "static/Corporate_Responsibility_05-99ff5f218307a5de2ecb14d276cc7cf7.jpg";